app.controller('OrderQuoteManageController',
    ['$rootScope', '$scope', '$http', '$state', '$stateParams',
        function ($rootScope, $scope, $http, $state, $stateParams) {

            $scope.order_id = $stateParams.order_id ? $stateParams.order_id : $rootScope.model.order.current_order._id;
            $scope.waiting_for_data = true;
            $scope.wrong_order_mode = false;
            $scope.visible_quote = null;


            $scope.view_model = {
                do_show_edit_order_ref: false,
                do_show_edit_margin: {},
                do_show_edit_discount: {}
            }

            $scope.currentDate = function () {
                return new Date();
            }

            $rootScope.service.account.requireMinimumData(function () {
                $rootScope.service.order.requestOrder($scope.order_id, function (success, order) {
                    $scope.waiting_for_data = false;
                    if (success) {
                        const isOrderQuote = $rootScope.service.order_helper.isOrderQuote(order);
                        if (isOrderQuote) {
                            $scope.visible_quote = order;
                        } else {
                            $scope.wrong_order_mode = true;
                        }
                    }
                })
            });

            $scope.startNewQuote = function () {
                const isCurrentOrder = !$scope.order_id || $scope.order_id === $rootScope.model.order.current_order._id;
                $rootScope.service.order.startNewOrder(true);
                if (isCurrentOrder) {
                    $scope.visible_quote = $rootScope.model.order;
                    $scope.wrong_order_mode = false;
                }
            }

            $scope.resumeOrder = function () {

                $rootScope.navigation_manager.requireInitialized(function () {
                    const routeOptions = $rootScope.service.order_helper.recentBrowseRoute($scope.visible_quote);
                    if (routeOptions) {
                        $state.go(routeOptions.route, routeOptions.options);
                        return;
                    }
                    $state.go('myba.dashboard');
                });
            };

            $scope.saveOrder = function (callback) {
                $rootScope.service.order.saveOrder($scope.visible_quote, function (success, order, messages) {
                    if (success) {
                        $scope.visible_quote = order;
                    }
                    if (callback) {
                        callback(success, order, messages);
                    }
                })
            };

            $scope.saveForLater = function () {
                $scope.saveOrder(function () {
                    $rootScope.service.order.startNewOrder();
                    $state.go('myba.dashboard');
                })

            };

            $scope.removeQuoteLine = function (lineIndex) {
                $scope.visible_quote.lines.splice(lineIndex, 1);
                $scope.saveOrder();
            };

            $scope.convertQuoteToOrder = function () {
                $rootScope.service.order_quote.convertQuoteToOrder($scope.visible_quote, function (success, order, messages) {
                    if (order) {
                        $rootScope.service.order.setCurrentOrder(order);
                        $rootScope.service.staff.requireCurrentOrderCustomer(function () {
                            $rootScope.service.tracking.track_event("Cart", "Started from saved quote");
                            $state.go('myba.order-checkout.review');
                        });
                    } else {
                        $state.go('myba.dashboard');
                    }

                });
            }

        }]);
